import { useEffect } from "react";

export const API_BASE_URL = "https://api.tajinvest.tj";

export const Prevenvideo = () => {
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    const videoElement = document.querySelector(".background-video");
    const disableControls = () => {
      if (videoElement) {
        videoElement.controls = false;
        videoElement.removeAttribute("controls");
      }
    };

    if (videoElement) {
      disableControls();
      videoElement.addEventListener("loadedmetadata", disableControls);
      videoElement.addEventListener("play", disableControls);
      videoElement.addEventListener("pause", disableControls);
      videoElement.addEventListener("webkitbeginfullscreen", disableControls);
      videoElement.addEventListener("click", disableControls);
    }

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      if (videoElement) {
        videoElement.removeEventListener("loadedmetadata", disableControls);
        videoElement.removeEventListener("play", disableControls);
        videoElement.removeEventListener("pause", disableControls);
        videoElement.removeEventListener(
          "webkitbeginfullscreen",
          disableControls
        );
        videoElement.removeEventListener("click", disableControls);
      }
    };
  }, []);
};

export default Prevenvideo;
